import React, { useContext, useEffect, useMemo } from "react";
import Page from "components/Page";
import { Col, Row } from "reactstrap";
import styles from "./AccountAdmin.module.scss";
import contractsIcon from "assets/images/contracts.svg";
import staffMembersIcon from "assets/images/staff-members.svg";
import timesheetIcon from "assets/images/timesheet-icon.svg";
import leavesIcon from "assets/images/leaves-icon.svg";
import notesIcon from "assets/images/notes.svg";
import performanceReviewIcon from "assets/images/performance_review.svg";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import constants from "../../../constants";
import { motion } from "framer-motion";
import { useOfficeDetail } from "repositories/office-repository";
import tooltipIcon from "assets/images/ico_admin.svg";
import { useLocation } from "react-router";
import { decodeId, setStorage } from "utils";
import { setOfficeNavigationContext } from "utils/officeNavigationContext";
import patientAppointmentIcon from "assets/images/patient_apppointment.svg";
import waitingListIcon from "assets/images/waiting_list.svg";
import patientMessageCenterIcon from "assets/images/patient_message_center.svg";
import DashboardIcon from "assets/images/Dashboard.svg";
import noticesIcon from "assets/images/notices.svg";
import PatientsIcon from "assets/images/patients.svg";
import timesheetReportIcon from "assets/images/timesheetReport.svg";
import timeSheetIcon from "assets/images/icTimeSheets.svg";
import SchedulerIcon from "assets/images/scheduler_new_icon.svg";
import TeamDashboardIcon from "assets/images/team_dashboard.svg";
import TaskIcon from "assets/images/task_management_card.svg";
import NotesIcon from "assets/images/notes_new.svg";
import PatientIcon from "assets/images/patient_chat_new.svg";
import PolicyIcon from "assets/images/policy.svg";
import { useSelector } from "react-redux";
import UpdateSubscriptionModel from "components/UpdateSubscriptionModel";
import { Store } from "containers/routes";
import { subscriptionReturnValues } from "reducers/Subscription";
import { usePatientAndTeamChatAccountAccess } from "repositories/family-member-repository";
import Info_book from "assets/images/info_book.svg";

let PageSize = 10;

function AccountAdmin({ history, match, t }) {
  const location = useLocation();
  const { setIsSubscriptionModel } = useContext(Store);
  const { isLoading, data } = useOfficeDetail(decodeId(match.params.officeId));
  const subscriptionDetails = useSelector((prev) => prev.Subscription);
  const {
    isNoticiesFeatureEnabled,
    isTaskFeatureEnabled,
    isNotesAndReminderFeatureEnabled,
    isPerformanceReviewFeatureEnabled,
    isDiscussionNotesFeatureEnabled,
    isPatientAppointmentFeatureEnabled,
    isPatientConversationFeatureEnabled,
    isSchedulerFeatureEnabled,
    isTeamConversationFeatureEnabled,
    subscriptionPlanId,
  } = useMemo(
    () => subscriptionReturnValues(subscriptionDetails, data?.ownerId),
    [subscriptionDetails, data?.ownerId]
  );
  const { data: checkData } = usePatientAndTeamChatAccountAccess(
    1,
    PageSize,
    data?.ownerId,
    { enabled: !!data?.ownerId }
  );

  const goBack = () => {
    history.push({
      pathname: constants.routes.staff.officeOptions.replace(
        ":officeId",
        match.params.officeId
      ),
      state: location.state,
    });
  };

  const handleRedirect = (officeId) => {
    history.push({
      pathname: constants.routes.appointment.appointmentScreen,
      state: {
        officeId: officeId,
        activetabs: 1,
        statusFilter: [],
        isfromPaitentDetail: true,
        isAdmin: true,
      },
    });
  };
  const handleRedirectDashBoard = (officeId) => {
    history.push({
      pathname: constants.routes.superAdmin.appointmentDashboard.replace(
        ":officeId",
        officeId
      ),
      state: {
        officeId: officeId,
        activetabs: 1,
        statusFilter: [],
        isfromPaitentDetail: true,
        isAdmin: true,
      },
    });
  };

  useEffect(() => {
    setStorage(constants.notes.cache.isChatFromDashBoard, false);
    setStorage(constants.notes.cache.isFromStaffAdmin, false);
    setStorage("is-from-appointment-dashboard", false);
    setStorage("isFromPatientAppointment", false);
    setStorage("isFromPatientChat", false);
  }, []);

  const handlePatientRedirect = (officeId) => {
    history.push(
      constants.routes.appointment.patients.replace(":officeId", officeId)
    );
    setStorage("officeState", {
      officeState: {},
    });
    setStorage("patient_from_admin", 1);
  };

  let officeName = null;
  if (location.state && location.state.officeName) {
    officeName = location.state.officeName;
  } else if (data?.name) {
    officeName = data.name;
  }

  useEffect(() => {
    setOfficeNavigationContext({
      officeSlection: false,
      staffOfficeSlection: false,
      isAdminControl: true,
      officeId: data?.id,
      officeName: data?.name,
      ownerId: data?.ownerId ?? null,
    });
  }, [data]);

  const chatAcess =
    Array.isArray(checkData) && checkData.length === 1 ? checkData[0] : null;

  return (
    <>
      <Page
        onBack={goBack}
        isTitleLoading={!officeName && isLoading}
        title={t("adminControls")}
        className={styles["page"]}
      >
        {officeName && (
          <div className={styles["page-subheading"] + " mt-1 pb-0"}>
            {officeName}
          </div>
        )}
        <>
          {/* Office Management */}
          <div>
            <p className={styles["mobile-text-size"] + " " + "margin30"}>
              {t("officeMangementCategory")}
            </p>
            <Row>
              <Col lg="4">
                <Card
                  to={constants.routes.accountOwner.staffGrid.replace(
                    ":officeId",
                    match.params.officeId
                  )}
                  icon={staffMembersIcon}
                  title={t("contracts.staffMembers")}
                  officeName={officeName}
                  extraStates={{
                    isAdmin: true,
                  }}
                />
              </Col>
              <Col lg="4">
                <Card
                  to={constants.routes.scheduler.calendar}
                  icon={SchedulerIcon}
                  title={t("navbar.scheduler")}
                  officeName={officeName}
                  isDisabled={!isSchedulerFeatureEnabled}
                  setIsSubscriptionModel={setIsSubscriptionModel}
                />
              </Col>
              <Col lg="4">
                <Card
                  to={constants.routes.dashboard.managerDashboard}
                  icon={TeamDashboardIcon}
                  title={t("dashBoard.teamDashboard")}
                  officeName={officeName}
                />
              </Col>

              <Col lg="4">
                <Card
                  to={constants.routes.accountOwner.timelinePreferences.replace(
                    ":officeId",
                    match.params.officeId
                  )}
                  icon={timeSheetIcon}
                  title={t("accountOwner.preferences")}
                  officeName={officeName}
                />
              </Col>
              <Col lg="4">
                <Card
                  to={
                    constants.routes.officePolicyManagements
                      .officePolicyManagement
                  }
                  icon={PolicyIcon}
                  title={t("navbar.policyManagement")}
                  isDisabled={!isTaskFeatureEnabled}
                />
              </Col>
              <Col lg="4">
                <Card
                  to={constants.routes.accountOwner.officeStaffInformation.replace(
                    ":officeId",
                    match.params.officeId
                  )}
                  extraStates={{
                    officeName: data?.name,
                    officeImage: data?.officeImage,
                    address: data?.address,
                    contactNumber: data?.contactNumber,
                  }}
                  icon={Info_book}
                  title={t("accountOwner.officeStaffInformation")}
                />
              </Col>
            </Row>
          </div>

          {/* Staff Management */}
          <div className="mt-4">
            <p className={styles["mobile-text-size"] + " " + "mt-4"}>
              {t("staffManagementCategory")}
            </p>
            <Row>
              <Col lg="4">
                <Card
                  to={constants.routes.accountOwner.timesheet.replace(
                    ":officeId",
                    match.params.officeId
                  )}
                  icon={timesheetIcon}
                  title={t("contracts.timesheet")}
                  officeName={officeName}
                />
              </Col>
              <Col lg="4">
                <Card
                  to={constants.routes.accountOwner.leaves.replace(
                    ":officeId",
                    match.params.officeId
                  )}
                  icon={leavesIcon}
                  officeName={officeName}
                  title={t("contracts.leaves")}
                />
              </Col>
              <Col lg="4">
                <Card
                  to={constants.routes.accountOwner.timesheetReport.replace(
                    ":officeId",
                    match.params.officeId
                  )}
                  icon={timesheetReportIcon}
                  title={t("staffTimesheet.timesheetReport")}
                  officeName={officeName}
                />
              </Col>
              <Col lg="4">
                <Card
                  to={constants.routes.chatModule}
                  icon={patientMessageCenterIcon}
                  title={t("messenger.teamConversation")}
                  isDisabled={!isTeamConversationFeatureEnabled}
                  setIsSubscriptionModel={setIsSubscriptionModel}
                />
              </Col>
              <Col lg="4">
                <Card
                  to={constants.routes.taskManagements.taskManagement}
                  icon={TaskIcon}
                  title={t("navbar.taskManagement")}
                  isDisabled={!isTaskFeatureEnabled}
                  setIsSubscriptionModel={setIsSubscriptionModel}
                />
              </Col>
              <Col lg="4">
                <Card
                  to={constants.routes.notes}
                  icon={NotesIcon}
                  title={t("Notes & Reminder")}
                  isDisabled={!isNotesAndReminderFeatureEnabled}
                  setIsSubscriptionModel={setIsSubscriptionModel}
                />
              </Col>
              <Col lg="4">
                <Card
                  to={constants.routes.accountOwner.performanceReview.replace(
                    ":officeId",
                    match.params.officeId
                  )}
                  icon={performanceReviewIcon}
                  title={t("performanceReview.performanceReview")}
                  officeName={officeName}
                  isDisabled={!isPerformanceReviewFeatureEnabled}
                  setIsSubscriptionModel={setIsSubscriptionModel}
                />
              </Col>

              <Col lg="4">
                <Card
                  to={constants.routes.accountOwner.notices.replace(
                    ":officeId",
                    match.params.officeId
                  )}
                  icon={noticesIcon}
                  title={t("notices.notice")}
                  officeName={officeName}
                  isDisabled={!isNoticiesFeatureEnabled}
                  setIsSubscriptionModel={setIsSubscriptionModel}
                />
              </Col>

              <Col lg="4">
                <Card
                  to={constants.routes.accountOwner.discussionNotes.replace(
                    ":officeId",
                    match.params.officeId
                  )}
                  icon={notesIcon}
                  title={t("discussionNote.discussionNote")}
                  officeName={officeName}
                  isDisabled={!isDiscussionNotesFeatureEnabled}
                  setIsSubscriptionModel={setIsSubscriptionModel}
                />
              </Col>
              <Col lg="4">
                <Card
                  to={constants.routes.accountOwner.forms.replace(
                    ":officeId",
                    match.params.officeId
                  )}
                  icon={contractsIcon}
                  title={t("contracts.formsAndContract")}
                  officeName={officeName}
                />
              </Col>
            </Row>
          </div>

          {/* Patient Management */}
          <div>
            <p className={styles["mobile-text-size"] + " " + "mt-4"}>
              {t("pateintManagementCategory")}
            </p>
            <Row>
              <Col lg="4">
                <Card
                  redirect={() => handlePatientRedirect(match.params.officeId)}
                  icon={PatientsIcon}
                  title={t("patients.patients")}
                  officeName={officeName}
                />
              </Col>
              <Col lg="4">
                <Card
                  redirect={() =>
                    handleRedirect(decodeId(match.params.officeId))
                  }
                  icon={patientAppointmentIcon}
                  officeName={officeName}
                  title="Patient Appointments"
                  isDisabled={!isPatientAppointmentFeatureEnabled}
                  setIsSubscriptionModel={setIsSubscriptionModel}
                />
              </Col>
              <Col lg="4">
                <Card
                  to={constants.routes.waitingList.replace(
                    ":officeId",
                    match.params.officeId
                  )}
                  icon={waitingListIcon}
                  title={t("waitingList.waitingList")}
                  officeName={officeName}
                />
              </Col>
              <Col lg="4">
                <Card
                  redirect={() =>
                    handleRedirectDashBoard(match.params.officeId)
                  }
                  icon={DashboardIcon}
                  title="Patient Dashboard"
                  officeName={officeName}
                />
              </Col>
              <Col lg="4">
                <Card
                  to={constants.routes.appointment.patientMessageCenter
                    .replace(":officeId", match.params.officeId)
                    .replace(
                      "/:patientId?",
                      match?.params?.patientId
                        ? `/${match?.params?.patientId}`
                        : ""
                    )
                    .replace(
                      "/:appointmentId?",
                      match?.params?.appointmentId
                        ? `/${match?.params?.appointmentId}`
                        : ""
                    )}
                  icon={patientMessageCenterIcon}
                  title="Patient Message Center"
                  officeName={officeName}
                />
              </Col>
              {chatAcess?.isPatientChat && (
                <Col lg="4">
                  <Card
                    to={constants.routes.patientChatModule}
                    icon={PatientIcon}
                    title={t("messenger.patientLiveChat")}
                    isDisabled={!isPatientConversationFeatureEnabled}
                    setIsSubscriptionModel={setIsSubscriptionModel}
                  />
                </Col>
              )}
            </Row>
          </div>
        </>
      </Page>
      <UpdateSubscriptionModel
        t={t}
        isFromOfficeOptions={true}
        plan={subscriptionPlanId}
      />
    </>
  );
}

function Card({
  to,
  icon,
  title,
  officeName,
  redirect,
  extraStates = {},
  isDisabled = false,
  setIsSubscriptionModel = () => {},
  callBackClick,
}) {
  const location = useLocation();
  if (redirect) {
    return (
      <motion.div
        whileHover={{ scale: constants.animation.hoverScale }}
        whileTap={{ scale: constants.animation.hoverScale }}
      >
        <span
          onClick={isDisabled ? () => {} : redirect}
          className={isDisabled ? "disabled" : "pointer"}
        >
          <div className={styles["card"]}>
            <div className={styles["tooltip-icon"]}>
              <img src={tooltipIcon} alt="icon" />
            </div>
            <img className={`${styles["icon"]} mr-2`} src={icon} alt="icon" />
            <h4>{title}</h4>
          </div>
        </span>
      </motion.div>
    );
  }
  return (
    <motion.div
      whileHover={{ scale: constants.animation.hoverScale }}
      whileTap={{ scale: constants.animation.hoverScale }}
    >
      <Link
        to={
          isDisabled
            ? "#"
            : {
                pathname: to,
                state: { ...location.state, officeName, ...extraStates },
              }
        }
        onClick={(e) => {
          if (isDisabled) {
            e.preventDefault();
            setIsSubscriptionModel(true);
          } else if (callBackClick) {
            callBackClick();
          }
        }}
      >
        <div
          className={`${styles["card"]} ${
            isDisabled ? styles["disabled"] : ""
          }`}
        >
          <div className={styles["tooltip-icon"]}>
            <img src={tooltipIcon} alt="icon" />
          </div>
          <img className={`${styles["icon"]} mr-2`} src={icon} alt="icon" />
          <h4>{title}</h4>
        </div>
      </Link>
    </motion.div>
  );
}

export default withTranslation()(AccountAdmin);
